export default {
  namespaced: true,
  state: {
    visible: false,
  },

  mutations: {
    SHOW_TEST_NOTICES_CFE_ALERT(state) {
      state.visible = true;
    },
    HIDE_TEST_NOTICES_CFE_ALERT(state) {
      state.visible = false;
    },
  },

  actions: {
    show({ commit }) {
      commit('SHOW_TEST_NOTICES_CFE_ALERT');
    },
    hide({ commit }) {
      commit('HIDE_TEST_NOTICES_CFE_ALERT');
    },
  },
};
